// extracted by mini-css-extract-plugin
export default {"outer-box":"QBBSvmwX4NqTGzC4qqcU","outer-box-main":"fFytC0TE_zACjXUNB2h9","type-default":"Tiz1DBYLWM1Zf6ldDvSY","common_bganimation":"zpJKTs46PWxZX1I6lshP"};